import { CTAPIConfiguration } from './utils/configuration';
import { RequestHelper } from './utils/request';
import { GeoProxyRestInterface } from './interfaces/_geoproxy.rest';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Suggestion } from '../models/interfaces/_geoproxy.model';

export class GeoProxyRest implements GeoProxyRestInterface {

    private configuration: CTAPIConfiguration;
    private requestHelper: RequestHelper;

    constructor(configuration: CTAPIConfiguration) {
        this.configuration = configuration;
        this.requestHelper = new RequestHelper(configuration);
    }

    /**
     * Request to notify new account creation.
     */
    getSuggestions(query: string, countryCode?: string): Observable<Suggestion[]> {
        return this.requestHelper.request({ data: { searchLocation: query, countryCode } },
            this.configuration.geoproxy.getSuggestions, this.configuration.httpClient
        ).pipe(
            map((response: {success: boolean, result: Suggestion[]}) => {
                if (!response.success) {
                    throw new Error('GeoProxy getSuggestions request failed');
                }
                return response.result;
            })
        );
    }
}
